/* 5LAX guide tools: no dependencies, storage, cookies or network requests. */
(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root && root.document) {
    root.FiveLaxGuideTools = api;
    if (root.document.readyState === 'loading') {
      root.document.addEventListener('DOMContentLoaded', function () { api.init(root.document); });
    } else { api.init(root.document); }
    root.document.addEventListener('shopify:section:load', function (event) { api.init(event.target); });
  }
}(typeof window !== 'undefined' ? window : null, function () {
  'use strict';
  var dimensionKeys = ['wallWidth', 'headWidth', 'gap', 'wallHeight', 'stickHeight', 'liftSpace'];
  function asNumber(value) {
    return value === '' || value === null || value === undefined ? NaN : Number(value);
  }
  function planPacks(count) {
    var best = null;
    for (var fives = 0; fives <= Math.ceil(count / 5); fives++) {
      var twos = Math.max(0, Math.ceil((count - fives * 5) / 2));
      var holders = fives * 5 + twos * 2;
      var option = { fives: fives, twos: twos, holders: holders, spare: holders - count };
      if (!best || option.spare < best.spare || (option.spare === best.spare && fives + twos < best.fives + best.twos)) best = option;
    }
    return best;
  }
  function calculateLayout(values) {
    var v = {}, errors = {};
    dimensionKeys.concat(['count']).forEach(function (key) { v[key] = asNumber(values[key]); });
    ['wallWidth', 'headWidth', 'wallHeight', 'stickHeight'].forEach(function (key) {
      if (!Number.isFinite(v[key]) || v[key] <= 0) errors[key] = 'Enter a measurement greater than zero.';
    });
    ['gap', 'liftSpace'].forEach(function (key) {
      if (!Number.isFinite(v[key]) || v[key] < 0) errors[key] = 'Enter zero or a positive measurement.';
    });
    if (!Number.isInteger(v.count) || v.count < 1 || v.count > 30) errors.count = 'Enter a whole number from 1 to 30.';
    if (Object.keys(errors).length) return { valid: false, errors: errors };
    var requiredWidth = v.count * v.headWidth + (v.count - 1) * v.gap;
    var requiredHeight = v.stickHeight + v.liftSpace;
    var fitsWidth = requiredWidth <= v.wallWidth + 1e-8;
    var fitsHeight = requiredHeight <= v.wallHeight + 1e-8;
    var margin = (v.wallWidth - requiredWidth) / 2;
    var centers = Array.from({ length: v.count }, function (_, index) { return margin + v.headWidth / 2 + index * (v.headWidth + v.gap); });
    return { valid: true, values: v, requiredWidth: requiredWidth, requiredHeight: requiredHeight,
      fitsWidth: fitsWidth, fitsHeight: fitsHeight, fits: fitsWidth && fitsHeight,
      margin: margin, centers: centers, packs: planPacks(v.count) };
  }
  function convertDimension(value, from, to) {
    if (!Number.isFinite(asNumber(value))) return '';
    if (from === to) return Number(value);
    return Number((Number(value) * (to === 'cm' ? 2.54 : 1 / 2.54)).toFixed(4));
  }
  function format(value) { return Number(value.toFixed(2)).toLocaleString('en-US', { maximumFractionDigits: 2 }); }
  function text(node, value) { node.textContent = value; }
  function printTool(tool) {
    var doc = tool.ownerDocument;
    doc.querySelectorAll('[data-five-print-active]').forEach(function (node) { node.removeAttribute('data-five-print-active'); });
    tool.setAttribute('data-five-print-active', '');
    var parent = tool.parentElement;
    while (parent && parent !== doc.body) { parent.setAttribute('data-five-print-ancestor', ''); parent = parent.parentElement; }
    doc.body.classList.add('five-tool-printing');
    var cleanup = function () {
      doc.body.classList.remove('five-tool-printing'); tool.removeAttribute('data-five-print-active');
      doc.querySelectorAll('[data-five-print-ancestor]').forEach(function (node) { node.removeAttribute('data-five-print-ancestor'); });
    };
    doc.defaultView.addEventListener('afterprint', cleanup, { once: true });
    doc.defaultView.print();
  }
  function drawPlan(svg, result, unit) {
    while (svg.firstChild) svg.removeChild(svg.firstChild);
    var ns = 'http://www.w3.org/2000/svg';
    function node(name, attributes, content) {
      var el = svg.ownerDocument.createElementNS(ns, name);
      Object.keys(attributes).forEach(function (key) { el.setAttribute(key, attributes[key]); });
      if (content !== undefined) el.textContent = content;
      svg.appendChild(el); return el;
    }
    node('title', {}, 'Vertical stick layout, with holder center positions measured from the left edge. Exact positions are listed below.');
    node('rect', { x: 1, y: 1, width: 558, height: 218, rx: 8, fill: '#f4f4ed', stroke: '#c9cbc0' });
    var scale = 520 / result.values.wallWidth;
    result.centers.forEach(function (center, i) {
      var x = 20 + center * scale, head = result.values.headWidth * scale;
      node('line', { x1: x, x2: x, y1: 80, y2: 183, stroke: '#555b43', 'stroke-width': 3 });
      node('path', { d: 'M ' + (x - head / 2) + ' 35 Q ' + (x - head / 2) + ' 80 ' + x + ' 92 Q ' + (x + head / 2) + ' 80 ' + (x + head / 2) + ' 35 Z', fill: '#dce69a', stroke: '#384329', 'stroke-width': 2 });
      if (result.values.count <= 12) node('text', { x: x, y: 62, 'text-anchor': 'middle', fill: '#202518', 'font-size': 14 }, String(i + 1));
    });
    node('text', { x: 280, y: 207, 'text-anchor': 'middle', fill: '#333b29', 'font-size': 13 }, 'Wall width ' + format(result.values.wallWidth) + ' ' + unit + ' · vertical view, schematic');
  }
  function initPlanner(tool) {
    if (tool.dataset.ready) return;
    tool.dataset.ready = 'true';
    var form = tool.querySelector('form'), units = form.elements.unit, previousUnit = units.value;
    var output = tool.querySelector('[data-plan-result]'), error = tool.querySelector('[data-plan-error]');
    var allInputs = dimensionKeys.concat(['count']);
    function clearResults() { output.hidden = true; error.hidden = true; }
    function updateUnitLabels() {
      tool.querySelectorAll('[data-unit-label]').forEach(function (label) { text(label, units.value); });
    }
    units.addEventListener('change', function () {
      dimensionKeys.forEach(function (key) { form.elements[key].value = convertDimension(form.elements[key].value, previousUnit, units.value); });
      previousUnit = units.value; updateUnitLabels(); clearResults();
    });
    allInputs.forEach(function (key) {
      form.elements[key].addEventListener('input', function () { this.removeAttribute('aria-invalid'); clearResults(); });
    });
    tool.querySelector('[data-example]').addEventListener('click', function () {
      var values = { wallWidth: 48, count: 4, headWidth: 7, gap: 2, wallHeight: 72, stickHeight: 42, liftSpace: 3 };
      allInputs.forEach(function (key) { form.elements[key].value = key === 'count' ? values[key] : convertDimension(values[key], 'in', units.value); form.elements[key].removeAttribute('aria-invalid'); });
      clearResults();
      text(tool.querySelector('[data-example-note]'), 'Example measurements loaded. Replace them with your own before mounting.');
    });
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var values = {};
      allInputs.forEach(function (key) { values[key] = form.elements[key].value; form.elements[key].removeAttribute('aria-invalid'); });
      var result = calculateLayout(values);
      if (!result.valid) {
        output.hidden = true;
        var keys = Object.keys(result.errors);
        keys.forEach(function (key) { form.elements[key].setAttribute('aria-invalid', 'true'); });
        text(error, 'Check the highlighted measurements. Use positive dimensions, zero or more clearance, and 1–30 whole sticks.');
        error.hidden = false; form.elements[keys[0]].focus(); return;
      }
      error.hidden = true;
      var unit = units.value;
      text(tool.querySelector('[data-plan-summary]'), result.fits ? 'Your measured layout fits.' : 'This layout needs more room.');
      text(tool.querySelector('[data-plan-space]'), 'Required space: ' + format(result.requiredWidth) + ' ' + unit + ' wide × ' + format(result.requiredHeight) + ' ' + unit + ' high, including your chosen clearance.');
      var advice = [];
      if (!result.fitsWidth) advice.push('You need ' + format(result.requiredWidth - result.values.wallWidth) + ' ' + unit + ' more width. Try fewer sticks or a wider space.');
      if (!result.fitsHeight) advice.push('You need ' + format(result.requiredHeight - result.values.wallHeight) + ' ' + unit + ' more height, including the space you allowed to lift a stick out.');
      if (result.fits) advice.push('Center the row with ' + format(result.margin) + ' ' + unit + ' between each outside head edge and the edge of your measured wall space.');
      text(tool.querySelector('[data-plan-advice]'), advice.join(' '));
      var detail = tool.querySelector('[data-plan-fit]'); detail.hidden = !result.fits;
      if (result.fits) {
        var list = tool.querySelector('[data-plan-centers]'); list.replaceChildren();
        result.centers.forEach(function (position, i) {
          var item = list.ownerDocument.createElement('li'); text(item, 'Holder ' + (i + 1) + ': ' + format(position) + ' ' + unit); list.appendChild(item);
        });
        drawPlan(tool.querySelector('svg'), result, unit);
        var packs = result.packs, parts = [];
        if (packs.fives) parts.push(packs.fives + ' × 5-pack');
        if (packs.twos) parts.push(packs.twos + ' × 2-pack');
        text(tool.querySelector('[data-plan-packs]'), 'Pack option: ' + parts.join(' + ') + ' (' + packs.holders + ' holders' + (packs.spare ? ', ' + packs.spare + ' spare' : '') + '). This minimizes spare holders, then the number of packs; it is not a price comparison.');
        tool.querySelector('[data-pack-two]').hidden = !packs.twos;
        tool.querySelector('[data-pack-five]').hidden = !packs.fives;
      }
      output.hidden = false;
      tool.querySelector('[data-plan-summary]').focus();
    });
    tool.querySelector('[data-print-plan]').addEventListener('click', function () { printTool(tool); });
    updateUnitLabels();
  }
  function initPocket(tool) {
    if (tool.dataset.ready) return;
    tool.dataset.ready = 'true';
    var selected = 1, buttons = tool.querySelectorAll('[data-hole]');
    var input = tool.querySelector('[data-hole-note]'), notes = {};
    function choose(number) {
      notes[selected] = input.value; selected = number; input.value = notes[selected] || '';
      buttons.forEach(function (button) { button.setAttribute('aria-pressed', String(Number(button.dataset.hole) === number)); });
      text(tool.querySelector('[data-selected-hole]'), 'Your note for hole ' + number);
    }
    buttons.forEach(function (button) { button.addEventListener('click', function () { choose(Number(button.dataset.hole)); }); });
    tool.querySelector('[data-print-recipe]').addEventListener('click', function () {
      notes[selected] = input.value;
      text(tool.querySelector('[data-print-pocket-meta]'), 'Head: ' + (tool.querySelector('#pocket-head').value || '________________') + ' · Mesh: ' + (tool.querySelector('#pocket-mesh').value || '________________'));
      var output = tool.querySelector('[data-recipe-lines]'); output.replaceChildren();
      for (var hole = 1; hole <= 20; hole++) {
        var item = output.ownerDocument.createElement('li'); text(item, 'Hole ' + hole + ': ' + (notes[hole] || '________________')); output.appendChild(item);
      }
      tool.querySelector('[data-recipe-print]').hidden = false; printTool(tool);
    });
    choose(1);
  }
  function initLibrary(tool) {
    if (tool.dataset.ready) return;
    tool.dataset.ready = 'true';
    var select = tool.querySelector('select');
    select.addEventListener('change', function () {
      var visible = 0;
      tool.querySelectorAll('[data-example-base]').forEach(function (card) {
        card.hidden = select.value !== 'all' && card.dataset.exampleBase !== select.value;
        if (!card.hidden) visible++;
      });
      text(tool.querySelector('[data-example-count]'), visible + ' photographed product ' + (visible === 1 ? 'example' : 'examples') + '. No tested dye recipes are published here.');
    });
  }
  function init(scope) {
    scope.querySelectorAll('[data-five-wall-planner]').forEach(initPlanner);
    scope.querySelectorAll('[data-five-pocket-notes]').forEach(initPocket);
    scope.querySelectorAll('[data-five-dye-library]').forEach(initLibrary);
  }
  return { calculateLayout: calculateLayout, planPacks: planPacks, convertDimension: convertDimension, init: init };
}));
